 <template lang="pug">
.portfolio(
  :style="{height: height}")
  b-header(:style="{ height: isMobi ? (currentPage === 1 && currentCat !== 0 && currentCat <= 40 ? '180px' : '50px') : '1.5rem', backgroundColor: currentPage !== 1 ? 'transparent' : '#fff' }")
    .sub_nav(v-if="currentPage !== 0")
      ul
        li.pc(:class="{selected: currentPage === 1 && currentCat === 0}", @click="setCat(0);turnToA(1)") {{langs[lang].all}}
        li(:class="{selected: currentPage === 1 && currentCat !== 0 && currentCat <= 40}", @click="setCat(20);turnToA(1)") BAI
        li(:class="{selected: currentCat === 42}", @click="setCat(42);turnToA(1)") FOF
    .detail_nav(v-if="(currentPage === 1) && currentCat !== 0 && currentCat <= 40")
      ul
        li(:class="{selected: currentCat === 20}" @click="setCat(20);turnToA(1)") {{langs[lang].Upgrade}}
        li(:class="{selected: currentCat === 18}" @click="setCat(18);turnToA(1)") {{langs[lang].Finance}}
        li(:class="{selected: currentCat === 38}" @click="setCat(38);turnToA(1)") {{langs[lang].Global}}
        li(:class="{selected: currentCat === 24}" @click="setCat(24);turnToA(1)") {{langs[lang].Social}}
        li(:class="{selected: currentCat === 40}" @click="setCat(40);turnToA(1)") {{langs[lang].Tech}}
  .container(
    ref="fullpage",
    v-fullpage="opts",
    @mousewheel.stop.prevent="mousewheel"
    @wheel.stop.prevent="mousewheel")
    .page.first(:style="{height: height}")
      .nav
        transition(name="left-in")
          .line(v-show="init")
        transition(name="right-in")
          .title(v-show="init") {{langs[lang].portfolio}}
        transition(name="bottom-in-delay")
          ul(v-show="init")
            li.pc(@click="setCat(0);turnToA(1)") {{langs[lang].all}}
            li(@click="setCat(20);turnToA(1)") BAI
            li(@click="setCat(42);turnToA(1)") FOF
      .all
        transition(
          appear,
          name="bottom-in")
          .item(@click="setCat(20);turnToA(1)")
            .title(style="font-weight: bold") BAI
            .desc {{langs[lang].bai}}
        transition(
          appear,
          name="bottom-in")
          .item(@click="setCat(42);turnToA(1)")
            .title FOF
            .desc {{langs[lang].FOF}}
    .page(
      ref="protfolioList"
      @touchend="touchend"
      :style="{height: height, overflowY: 'auto'}")
      .table(:style="{marginTop: isMobi ? (currentPage === 1) && currentCat !== 0 && currentCat <= 40 ? '180px' : '50px' : '1.66667rem'}"
             @mousewheel.stop.prevent="wheel"
             @wheel.stop.prevent="wheel")
        transition-group(
          appear,
          @before-enter="beforeEnter",
          @enter="enter",
          mode="out-in")
          .item(
            :key="index",
            :data-index="index",
            v-for="(item, index) in currentCatList"
            @click.stop.prevent="setCurrent(index)",
            @mouseenter.stop.prevent="mouseEnter(index)",
            @mouseleave.stop.prevent="mouseLeave")
            img(:src="item.logo")
            transition(name="slide" mode="out-in")
              .desc.pc(v-if="currentLogo == index")
                .title PORTFOLIO
                hr
                p {{lang === 'zh' ? item.title : item.title_en}}
  transition(name="up" mode="out-in")
    .detail_icon(v-show="opend")
      .close(@click="close")
        img(:src="require('../assets/logo_about.png')")
        .iconfont &#xe605;
      .bg(@click="openLink(list[currentIndex].link)")
        transition(name="bottom-in")
          img.logo(:src="list[currentIndex] && list[currentIndex].logo", v-show="opend")
        transition(name="bottom-in")
          .title(v-show="opend") {{list[currentIndex] && (lang === 'zh' ? list[currentIndex].title : list[currentIndex].title_en)}}
        transition(name="bottom-in")
          .desc(v-show="opend", v-html="list[currentIndex] && (lang === 'zh' ? list[currentIndex].content : list[currentIndex].content_en)")
</template>

<script>
import _ from 'lodash'
import footer from './footer'
import header from './header'
import fanpage from '../mixin/fanpage.js'
const Portfolio = {
  mixins: [fanpage],
  props: [],
  data () {
    return {
      totalPage: 1,
      current: 0,
      currentCat: 0,
      opend: false,
      currentLogo: -1,
      moving: false,
      list: [],
      langs: {
        en: {
          portfolio: 'PORTFOLIO',
          all: 'ALL',
          Upgrade: 'Urbanization and Retail',
          Finance: 'Finance',
          Global: 'China Based Global Company',
          Social: 'Social, Media & Content',
          Tech: 'Tech & Infrastructure',
          bai: 'Bertelsmann’s investment arm in ideal of creating better history with first movers',
          FOF: 'Fund investments broadening BAI’s network and knowledge base',
          dream: 'An angel fund supporting entrepreneurs who dream what they want to dream'
        },
        zh: {
          portfolio: '被投企业',
          all: '全部',
          Upgrade: '城镇化与零售',
          Finance: '新金融',
          Global: '移动出海',
          Social: '社交/媒体/内容',
          Tech: '新科技/企业服务',
          bai: '由国际传媒、教育、服务巨头贝塔斯曼集团全资控股，旗下管理的资金规模超过30亿美元，坚持走精品路线，寻找早期到成长期的市场领先者，创新开创者和趋势引领者',
          FOF: '基金投资拓展BAI的投资领域和知识体系',
          dream: '数千万美金规模的天使基金，支持“敢想敢做”的创业者'
        }
      }
    }
  },
  beforeMount () {
    this.animateCtrl = []
    this.currentCat = +this.$route.query.cat || 0
    this.current = +this.$route.query.id || 0
    if (this.current) this.opend = true
    this.currentPage = +this.$route.query.page || 0
    this.getPortfolio({
      categories: this.currentCat
    })
  },
  mounted () {
    this.turnTo(this.currentPage)
  },
  components: {
    bFooter: footer,
    bHeader: header
  },
  computed: {
    lang () {
      return localStorage.lang
    },
    currentIndex () {
      return _.findIndex(this.list, {id: this.current})
    },
    currentCatList () {
      let result = []
      if (this.currentPage === 1) {
        if (this.currentCat === 0) {
          result = this.list
        } else {
          result = _.filter(this.list, {categories: this.currentCat})
        }
      } else if (this.currentPage === 2) {
        result = _.filter(this.list, {categories: 42})
      } else if (this.currentPage === 3) {
        result = _.filter(this.list, {categories: 44})
      }
      if (this.isMobi) {
        return result
      } else {
        let len = (9 - (result.length % 9)) % 9
        return result.concat(new Array(len).fill(''))
      }
    },
    isMobi () {
      return window.isMobi
    }
  },
  methods: {
    turnToA (page) {
      this.turnTo(page)
      this.$moveTo(page)
    },
    touchend (e) {
      let dom = this.$refs.protfolioList
      if (dom.scrollTop === dom.scrollHeight - dom.clientHeight) {
        this.getPortfolio({
          categories: this.currentCat,
          page: Math.floor(dom.scrollTop / dom.clientHeight) + 1
        })
      }
    },
    getPortfolio (options) {
      let lang = ''
      let cate = ''
      if (this.lang === 'zh') {
        lang = 54
      } else {
        lang = 56
      }
      if (options.categories) {
        cate = `&categories=${options.categories}`
      }
      if (!options.page) {
        options.page = 1
      }
      window.$http.get(window.hostName + `wp-json/wp/v2/portfolio?per_page=18&page=${options.page}&tags=${lang}` + cate).then(res => {
        let list = this.list
        list.push(...res.data.map(item => {
          return {
            id: item.id,
            link: item.link,
            logo: item.logo.guid,
            title: item.title.rendered,
            title_en: item.title_en || item.title.rendered,
            content: item.content.rendered,
            content_en: item.content_en || item.content.rendered,
            categories: item.categories[0]
          }
        }))
        this.list = _.uniqBy(list, function (item) {
          return item.id
        })
        // this.list.sort((a, b) => {
        //   return a.title.localeCompare(b.title)
        // })
        this.$nextTick(function () {
          this.turnTo(this.currentPage)
          // DOM 更新了
        })
      })
    },
    openLink (link) {
      window.open(link)
    },
    parent (e, query) {
      for (var i = e.target; i !== document.rootElement; i = i.parentNode) {
        if (i.className.indexOf(query) !== -1) return i
      }
      return null
    },
    close () {
      this.opend = false
    },
    open () {
      this.opend = true
    },
    mouseEnter (index) {
      if (this.currentCatList[index]) {
        this.currentLogo = index
      }
    },
    mouseLeave () {
      this.currentLogo = -1
    },
    setCurrent (id) {
      if (this.currentCatList[id]) {
        this.current = this.currentCatList[id].id
        this.opend = true
      }
    },
    setCat (id) {
      if (this.opend) return
      this.currentCat = id
      if (this.mobi) {
        this.currentPage = 1
      } else {
        this.currentPage = +this.$route.query.page + 1 || 0
      }
      this.getPortfolio({
        categories: this.currentCat
      })
    },
    beforeEnter: function (el) {
      window.Velocity.hook(el, 'translateX', '-200px')
      window.Velocity.hook(el, 'opacity', 0)
    },
    enter: function (el, done) {
      var delay = el.dataset.index * 50 * Math.random()
      window.Velocity(
        el,
        {
          opacity: 1,
          translateX: 0
        },
        {
          duration: 1000,
          delay,
          complete: done
        }
      )
    },
    wheel (e) {
      if (this.moving) return
      let _this = this
      this.moving = true
      let dom = this.parent(e, 'table')
      let direction = e.deltaY > 0 ? 1 : -1
      let height = dom.scrollTop
      window.Velocity(
        dom,
        'scroll',
        {
          offset: 20,
          mobileHA: false,
          progress: function (elements, complete, remaining, start, tweenValue) {
            dom.scrollTop = height + direction * dom.clientHeight * complete
          },
          complete: () => {
            setTimeout(() => {
              _this.getPortfolio({
                categories: this.currentCat,
                page: Math.floor(dom.scrollTop / dom.clientHeight) + 1
              })
              this.moving = false
            }, 400)
          }
        }
      )
    }
  }
}
export default Portfolio
</script>

<style scoped lang="stylus">
@import '../common.styl'
@media (max-width: 720px) {
  .header {
    position: fixed;
    height: 3rem;
    width: 100%;
    top: 0;
    left: 0;
    background: #fff;
    background: transparent;
  }
  .portfolio{
    .first{
      .all{
        .item{
          margin-top: 150px;
          .title{
            text-align: center;
            color: #e50027;
            font-size: 100px;
            font-weight: normal;
          }
          .desc{
            text-align: center;
            font-size: 60px;
            width: 1600px;
            margin: 60px auto 0;
          }
        }
      }
    }
    .sub_nav{
      position: absolute;
      z-index: 99;
      cursor: pointer;
      width: 1080px;
      top: 30px;/*no*/
      left: 420px;
      font-size: 12px;/*no*/
      font-weight: bold;
      color: #808080;
      ul{
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: space-between;
        li{
          list-style: none;
          float: left;
          padding: 2px 10px 3px;
          margin-right: 0;
          &:hover, &.selected{
            display: inline-block;
            list-style: none;
            font-weight: bold;
            color: #002b69;
            border-bottom: 3px solid #002b69;
          }
        }
      }
    }
    .table{
      width: 1600px;
      overflow: hidden;
      margin: 50px auto;/*no*/
      .item{
        float: left;
        width: 800px;
        height: 416px;
        border-right: 1px solid #002b69;/*no*/
        border-bottom: 1px solid #002b69;/*no*/
        &:nth-child(2n){
          border-right: none;
        }
        img{
          width: 100%;
        }
      }
    }
    .detail_nav{
      transition: all .5s;
      z-index: 999;
      position: absolute;
      cursor: pointer;
      width: 1200px;
      top: 60px;/*no*/
      left: 420px;
      ul{
        overflow: hidden;
        margin: 0 auto;
        padding: 0;
        li{
          list-style: none;
          font-size: 72px;
          color: #999;
          padding-right: 0px;
          margin-bottom: 30px;
          &:hover, &.selected{
            color: #333333;
          }
        }
      }
    }
    .detail_icon{
      position: fixed;
      width: 100%;
      bottom: 0;
      left: 0;
      height: 85vh;
      z-index: 999;
      background: #f2f2f2;
      .close{
        position: absolute;
        z-index: 99;
        width: 448px;
        height: 224px;
        top: -112px;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
        img{
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
        }
        .iconfont{
          color: #fff;
          font-size: 14px;/*no*/
          position: absolute;
          z-index: 999;
          top: 80px;
          width: 100%;
          text-align: center;
          &:hover{
            transition: all .5s;
            transform: rotate(90deg);
          }
        }
      }
      .bg{
        .logo{
          height: 60px;/*no*/
          display: block;
          margin: 150px auto 0;
        }
        .title{
          text-align: center;
          font-size: 30px;/*no*/
          font-weight: bold;
          color: #002b69;
        }
        .desc{
          font-size: 14px;/*no*/
          width: 1600px;
          height: 1500px;
          overflow-y: scroll;;
          margin: 50px auto 0;
        }
      }
    }
  }
}
@media (min-width: 720px) {
  .page{
    overflow: hidden;
    z-index: 999;
  }
  .all{
    cursor: pointer;
    display: flex;
    justify-content: space-around;
    margin-top: 200px;
    .item{
      padding: 0 100px;
      flex: 1;
      text-align: center;
      box-sizing: border-box;
      padding: 0 50px;
      .title{
        font-size: 60px;
        line-height: 60px;
        text-align: center;
        color: #e50027;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
      }
      .desc{
        margin-top: 30px;
        font-size: 18px;
        color: #979797;
      }
    }
  }
  .sub_nav{
    transition: all .5s;
    position: absolute;
    z-index: 999;
    cursor: pointer;
    width: 900px;
    top: 61px;
    left: 500px;
    font-size: 19px;
    font-weight: bold;
    color: #808080;
    ul{
      display: flex;
      justify-content: space-between;
      padding: 0;
      margin: 0;
      li{
        float: left;
        padding: 2px 10px 3px;
        &+li{
          margin-left: 100px;
        }
        &:hover, &.selected{
          display: inline-block;
          list-style: none;
          color: #002b69;
          border-bottom: 3px solid #002b69;/*no*/
        }
      }
    }
  }
  .detail_nav{
    transition: all .5s;
    position: absolute;
    z-index: 999;
    cursor: pointer;
    width: 960px;
    top: 100px;
    left: 500px;
    ul{
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      margin: 0 auto;
      padding: 0;
      li{
        list-style: none;
        float: left;
        font-size: 18px;
        color: #999;
        padding-right: 0px;
        flex-basis: 20%;
        &+li{
          margin-left: 10px;
        }
        &:hover, &.selected{
          color: #333333;
        }
      }
    }
  }
  .table{
    position: relative;
    width: 1500px;
    height: 780px;
    margin: 0 auto;
    margin-top: 200px;
    overflow: hidden;
    .item{
      overflow: hidden;
      position: relative;
      float: left;
      width: 500px;
      height: 260px;
      border-right: 1px solid #002b69;/*no*/
      border-bottom: 1px solid #002b69;/*no*/
      cursor: pointer;
      .desc{
        position: absolute;
        width: 100%;
        padding: 91.88px 109.38px;
        height: 100%;
        top: 0;
        left: 0;
        font-size: 18px;
        text-align: center;
        color: #fff;
        background: url('../assets/bg_blue.png') center / cover;
        .title{
          opacity: .5;
        }
        hr{
          margin: 10px 0;
          border: none;
          border-bottom: 1px solid #fff;
        }
        p{
          margin: 0;
          font-size: 21px;
        }
      }
      &:nth-child(3n){
        border-right: none;
      }
      &:nth-child(9n+7),
      &:nth-child(9n+8),
      &:nth-child(9n){
        border-bottom: none;
      }
      img{
        width: 80%;
        margin: 5% 10%;
      }
    }
  }
  .detail_icon{
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    height: 82%;
    z-index: 999;
    background: #f2f2f2;
    .close{
      position: absolute;
      z-index: 99;
      width: 112px;
      height: 56px;
      top: -28px;
      left: 50%;
      transform: translateX(-50%);
      cursor: pointer;
      img{
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .iconfont{
        color: #fff;
        font-size: 32px;
        position: absolute;
        z-index: 999;
        top: 15px;
        line-height: 32px;
        width: 32px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        &:hover{
          transition: all .5s;
          transform: translateX(-50%) rotate(90deg);
        }
      }
    }
    .bg{
      cursor: pointer;
      .logo{
        height: 100px;
        display: block;
        margin: 60px auto 0;
      }
      .title{
        text-align: center;
        font-size: 80px;
        font-weight: bold;
        color: #002b69;
      }
      .desc{
        font-size: 24px;
        line-height: 2;
        color: #666;
        width: 1000px;
        height: 500px;
        overflow-y: auto;
        position: relative;
        left: 20px;
        margin: 50px auto 0;
      }
    }
  }
  .slide-enter-active {
    transition: all .3s ease-out
  }
  .slide-leave-active {
    transition: all .3s ease-out
  }
  .slide-enter, .slide-leave-to{
    transform: translateX(-500px);
    opacity: 0;
  }
  .up-enter-active {
    transition: all .3s ease-out
  }
  .up-leave-active {
    transition: all .3s ease-out
  }
  .up-enter, .up-leave-to{
    transform: translateY(1000px);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// portfolio.vue?2eafba6d